import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import {
  dailyAttendanceFieldResponse,
  dailyAttendanceFieldRepository,
} from "features/ms6/data/ms6.repository";

export enum dailyAttendanceFieldState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyAttendanceFieldState;
  message: string;
}

const initialState: InitialState = {
  status: dailyAttendanceFieldState.initial,
  message: "",
};

export const dailyAttendanceField = createAsyncThunk(
  "dailyAttendanceField",
  async (_, { rejectWithValue }) => {
    try {
      const response: dailyAttendanceFieldResponse =
        await dailyAttendanceFieldRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyAttendanceFieldSlice = createSlice({
  name: "dailyAttendanceField",
  initialState,
  reducers: {
    resetdailyAttendanceField: (state) => {
      state.status = dailyAttendanceFieldState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyAttendanceField.pending, (state) => {
        state.status = dailyAttendanceFieldState.inProgress;
      })
      .addCase(dailyAttendanceField.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = dailyAttendanceFieldState.success;
          state.message = message;
        }
      })
      .addCase(dailyAttendanceField.rejected, (state, action) => {
        state.status = dailyAttendanceFieldState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailyAttendanceField = (state: RootState) =>
  state.dailyAttendanceField;
export const { resetdailyAttendanceField } = dailyAttendanceFieldSlice.actions;
export default dailyAttendanceFieldSlice.reducer;
